// @generated by protoc-gen-es v1.9.0 with parameter "target=ts"
// @generated from file no/jotta/openapi/search/search.v2.proto (package no.jotta.openapi.search.v2, syntax proto3)
/* eslint-disable */
// @ts-nocheck
import { Message, proto3 } from "@bufbuild/protobuf";
import { PathItem } from "../file/file.v2_pb.js";
import { Language } from "../language_pb.js";
import { Person } from "../people/v1/people.v1_pb.js";
/**
 * @generated from message no.jotta.openapi.search.v2.PhotoMatch
 */
export class PhotoMatch extends Message {
    /**
     *    string owner = 1;
     *
     * @generated from field: string md5 = 2;
     */
    md5 = "";
    /**
     * @generated from field: string thumbnail_url = 3;
     */
    thumbnailUrl = "";
    /**
     * @generated from field: string photo_id = 4;
     */
    photoId = "";
    /**
     *    float score = 5;
     *
     * @generated from field: uint32 height = 6;
     */
    height = 0;
    /**
     * @generated from field: uint32 width = 7;
     */
    width = 0;
    /**
     * @generated from field: optional string video_duration = 8;
     */
    videoDuration;
    /**
     * @generated from field: optional no.jotta.openapi.search.v2.PhotoMatch.DebugInfo debug_info = 9;
     */
    debugInfo;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.search.v2.PhotoMatch";
    static fields = proto3.util.newFieldList(() => [
        { no: 2, name: "md5", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 3, name: "thumbnail_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 4, name: "photo_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 6, name: "height", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
        { no: 7, name: "width", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
        { no: 8, name: "video_duration", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
        { no: 9, name: "debug_info", kind: "message", T: PhotoMatch_DebugInfo, opt: true },
    ]);
    static fromBinary(bytes, options) {
        return new PhotoMatch().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PhotoMatch().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PhotoMatch().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PhotoMatch, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.search.v2.PhotoMatch.DebugInfo
 */
export class PhotoMatch_DebugInfo extends Message {
    /**
     * @generated from field: float similarity_score = 1;
     */
    similarityScore = 0;
    /**
     * @generated from field: float linear_score = 2;
     */
    linearScore = 0;
    /**
     * @generated from field: float aesthetic_score = 3;
     */
    aestheticScore = 0;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.search.v2.PhotoMatch.DebugInfo";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "similarity_score", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
        { no: 2, name: "linear_score", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
        { no: 3, name: "aesthetic_score", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    ]);
    static fromBinary(bytes, options) {
        return new PhotoMatch_DebugInfo().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PhotoMatch_DebugInfo().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PhotoMatch_DebugInfo().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PhotoMatch_DebugInfo, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.search.v2.SearchRequest
 */
export class SearchRequest extends Message {
    /**
     * @generated from field: string query = 1;
     */
    query = "";
    /**
     * narrow search to specific paths. If left empty, the search is global
     *
     * @generated from field: repeated string path = 2;
     */
    path = [];
    /**
     * @generated from field: int32 page_index = 3;
     */
    pageIndex = 0;
    /**
     * string namespace_id = 5;
     *
     * @generated from field: int32 page_size = 4;
     */
    pageSize = 0;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.search.v2.SearchRequest";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "query", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 2, name: "path", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
        { no: 3, name: "page_index", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
        { no: 4, name: "page_size", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    ]);
    static fromBinary(bytes, options) {
        return new SearchRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SearchRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SearchRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SearchRequest, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.search.v2.SearchResponse
 */
export class SearchResponse extends Message {
    /**
     * @generated from field: no.jotta.openapi.file.v2.PathItem match = 1;
     */
    match;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.search.v2.SearchResponse";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "match", kind: "message", T: PathItem },
    ]);
    static fromBinary(bytes, options) {
        return new SearchResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SearchResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SearchResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SearchResponse, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.search.v2.PhotoSearchRequest
 */
export class PhotoSearchRequest extends Message {
    /**
     * @generated from field: string query = 1;
     */
    query = "";
    /**
     * @generated from field: optional bool debug = 2;
     */
    debug;
    /**
     * @generated from field: optional float minimum_aesthetic_score = 3;
     */
    minimumAestheticScore;
    /**
     * Optional parameter to filter results to only include results with these people. With multiple IDs,
     * results are combined with AND.
     *
     * @generated from field: repeated string person_id = 4;
     */
    personId = [];
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.search.v2.PhotoSearchRequest";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "query", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 2, name: "debug", kind: "scalar", T: 8 /* ScalarType.BOOL */, opt: true },
        { no: 3, name: "minimum_aesthetic_score", kind: "scalar", T: 2 /* ScalarType.FLOAT */, opt: true },
        { no: 4, name: "person_id", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    ]);
    static fromBinary(bytes, options) {
        return new PhotoSearchRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PhotoSearchRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PhotoSearchRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PhotoSearchRequest, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.search.v2.PhotoSearchResponse
 */
export class PhotoSearchResponse extends Message {
    /**
     * @generated from field: repeated no.jotta.openapi.search.v2.PhotoMatch matches = 1;
     */
    matches = [];
    /**
     * @generated from field: repeated string matched_person_ids = 2;
     */
    matchedPersonIds = [];
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.search.v2.PhotoSearchResponse";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "matches", kind: "message", T: PhotoMatch, repeated: true },
        { no: 2, name: "matched_person_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    ]);
    static fromBinary(bytes, options) {
        return new PhotoSearchResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PhotoSearchResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PhotoSearchResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PhotoSearchResponse, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.search.v2.PhotoSearchQuerySuggestionsRequest
 */
export class PhotoSearchQuerySuggestionsRequest extends Message {
    /**
     * Optional parameter to override language for the localization.
     * This is mainly useful for apps that have a different language from the customer.language,
     * such as mobile apps that follow the OS language instead of the customer.language.
     *
     * @generated from field: optional no.jotta.openapi.Language language = 1;
     */
    language;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.search.v2.PhotoSearchQuerySuggestionsRequest";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "language", kind: "enum", T: proto3.getEnumType(Language), opt: true },
    ]);
    static fromBinary(bytes, options) {
        return new PhotoSearchQuerySuggestionsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PhotoSearchQuerySuggestionsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PhotoSearchQuerySuggestionsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PhotoSearchQuerySuggestionsRequest, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.search.v2.PhotoSearchQuerySuggestionsResponse
 */
export class PhotoSearchQuerySuggestionsResponse extends Message {
    /**
     * @generated from field: repeated string suggested_queries = 1;
     */
    suggestedQueries = [];
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.search.v2.PhotoSearchQuerySuggestionsResponse";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "suggested_queries", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    ]);
    static fromBinary(bytes, options) {
        return new PhotoSearchQuerySuggestionsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PhotoSearchQuerySuggestionsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PhotoSearchQuerySuggestionsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PhotoSearchQuerySuggestionsResponse, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.search.v2.FindSimilarPhotosRequest
 */
export class FindSimilarPhotosRequest extends Message {
    /**
     * @generated from field: string photo_id = 1;
     */
    photoId = "";
    /**
     * @generated from field: optional bool debug = 2;
     */
    debug;
    /**
     * @generated from field: optional float minimum_aesthetic_score = 3;
     */
    minimumAestheticScore;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.search.v2.FindSimilarPhotosRequest";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "photo_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 2, name: "debug", kind: "scalar", T: 8 /* ScalarType.BOOL */, opt: true },
        { no: 3, name: "minimum_aesthetic_score", kind: "scalar", T: 2 /* ScalarType.FLOAT */, opt: true },
    ]);
    static fromBinary(bytes, options) {
        return new FindSimilarPhotosRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new FindSimilarPhotosRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new FindSimilarPhotosRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(FindSimilarPhotosRequest, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.search.v2.FindSimilarPhotosResponse
 */
export class FindSimilarPhotosResponse extends Message {
    /**
     * @generated from field: repeated no.jotta.openapi.search.v2.PhotoMatch matches = 1;
     */
    matches = [];
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.search.v2.FindSimilarPhotosResponse";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "matches", kind: "message", T: PhotoMatch, repeated: true },
    ]);
    static fromBinary(bytes, options) {
        return new FindSimilarPhotosResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new FindSimilarPhotosResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new FindSimilarPhotosResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(FindSimilarPhotosResponse, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.search.v2.AutoCompleteSearchQueryRequest
 */
export class AutoCompleteSearchQueryRequest extends Message {
    /**
     * @generated from field: string query = 1;
     */
    query = "";
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.search.v2.AutoCompleteSearchQueryRequest";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "query", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    ]);
    static fromBinary(bytes, options) {
        return new AutoCompleteSearchQueryRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AutoCompleteSearchQueryRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AutoCompleteSearchQueryRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AutoCompleteSearchQueryRequest, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.search.v2.AutoCompleteSearchQueryResponse
 */
export class AutoCompleteSearchQueryResponse extends Message {
    /**
     * @generated from field: repeated no.jotta.openapi.people.v1.Person person_suggestion = 1;
     */
    personSuggestion = [];
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.search.v2.AutoCompleteSearchQueryResponse";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "person_suggestion", kind: "message", T: Person, repeated: true },
    ]);
    static fromBinary(bytes, options) {
        return new AutoCompleteSearchQueryResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AutoCompleteSearchQueryResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AutoCompleteSearchQueryResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AutoCompleteSearchQueryResponse, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.search.v2.WaitlistStatus
 */
export class WaitlistStatus extends Message {
    /**
     * @generated from field: no.jotta.openapi.search.v2.WaitlistStatus.Status status = 1;
     */
    status = WaitlistStatus_Status.UNKNOWN;
    /**
     * @generated from field: int32 waitlist_position = 2;
     */
    waitlistPosition = 0;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.search.v2.WaitlistStatus";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "status", kind: "enum", T: proto3.getEnumType(WaitlistStatus_Status) },
        { no: 2, name: "waitlist_position", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    ]);
    static fromBinary(bytes, options) {
        return new WaitlistStatus().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new WaitlistStatus().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new WaitlistStatus().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(WaitlistStatus, a, b);
    }
}
/**
 * @generated from enum no.jotta.openapi.search.v2.WaitlistStatus.Status
 */
export var WaitlistStatus_Status;
(function (WaitlistStatus_Status) {
    /**
     * @generated from enum value: UNKNOWN = 0;
     */
    WaitlistStatus_Status[WaitlistStatus_Status["UNKNOWN"] = 0] = "UNKNOWN";
    /**
     * @generated from enum value: INACTIVE = 1;
     */
    WaitlistStatus_Status[WaitlistStatus_Status["INACTIVE"] = 1] = "INACTIVE";
    /**
     * @generated from enum value: ON_WAITLIST = 2;
     */
    WaitlistStatus_Status[WaitlistStatus_Status["ON_WAITLIST"] = 2] = "ON_WAITLIST";
    /**
     * @generated from enum value: ACTIVE = 3;
     */
    WaitlistStatus_Status[WaitlistStatus_Status["ACTIVE"] = 3] = "ACTIVE";
})(WaitlistStatus_Status || (WaitlistStatus_Status = {}));
// Retrieve enum metadata with: proto3.getEnumType(WaitlistStatus_Status)
proto3.util.setEnumType(WaitlistStatus_Status, "no.jotta.openapi.search.v2.WaitlistStatus.Status", [
    { no: 0, name: "UNKNOWN" },
    { no: 1, name: "INACTIVE" },
    { no: 2, name: "ON_WAITLIST" },
    { no: 3, name: "ACTIVE" },
]);
/**
 * @generated from message no.jotta.openapi.search.v2.GetWaitlistStatusRequest
 */
export class GetWaitlistStatusRequest extends Message {
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.search.v2.GetWaitlistStatusRequest";
    static fields = proto3.util.newFieldList(() => []);
    static fromBinary(bytes, options) {
        return new GetWaitlistStatusRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetWaitlistStatusRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetWaitlistStatusRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetWaitlistStatusRequest, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.search.v2.GetWaitlistStatusResponse
 */
export class GetWaitlistStatusResponse extends Message {
    /**
     * @generated from field: no.jotta.openapi.search.v2.WaitlistStatus status = 1;
     */
    status;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.search.v2.GetWaitlistStatusResponse";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "status", kind: "message", T: WaitlistStatus },
    ]);
    static fromBinary(bytes, options) {
        return new GetWaitlistStatusResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetWaitlistStatusResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetWaitlistStatusResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetWaitlistStatusResponse, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.search.v2.JoinWaitlistRequest
 */
export class JoinWaitlistRequest extends Message {
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.search.v2.JoinWaitlistRequest";
    static fields = proto3.util.newFieldList(() => []);
    static fromBinary(bytes, options) {
        return new JoinWaitlistRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new JoinWaitlistRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new JoinWaitlistRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(JoinWaitlistRequest, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.search.v2.JoinWaitlistResponse
 */
export class JoinWaitlistResponse extends Message {
    /**
     * @generated from field: no.jotta.openapi.search.v2.WaitlistStatus status = 1;
     */
    status;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.search.v2.JoinWaitlistResponse";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "status", kind: "message", T: WaitlistStatus },
    ]);
    static fromBinary(bytes, options) {
        return new JoinWaitlistResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new JoinWaitlistResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new JoinWaitlistResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(JoinWaitlistResponse, a, b);
    }
}
